import React from 'react';
import { Chip } from '@mui/material';
import { DISCOUNT_BADGE_TEXT } from 'shared';
import { isDiscountActive } from 'utils';

type DiscountBadgeProps = {
  sx?: object;
};

export const DiscountBadge: React.FC<DiscountBadgeProps> = ({ sx = {} }) => {
  if (!isDiscountActive()) {
    return null;
  }

  return (
    <Chip
      label={DISCOUNT_BADGE_TEXT}
      sx={{
        backgroundColor: '#169C99',
        color: 'white',
        fontWeight: 700,
        fontSize: '12px',
        borderRadius: '100px',
        border: '1px solid #FFFFFF',
        ...sx,
      }}
    />
  );
};
